export default __webpack_public_path__ + "static/media/brady_o.0830a5b4.jpg";